// extracted by mini-css-extract-plugin
export var layoutContainer = "_e4-0";
export var layoutContainerNoRounding = "_e4-6";
export var layoutContainerOpen = "_e4-5";
export var layoutContainerResizing = "_e4-1";
export var mainContent = "_e4-2";
export var resizeDivider = "_e4-3";
export var slidePanel = "_e4-4";